/* template */
<template><div class="order-info"><div class="status-text">{{ statusName }}</div><mpx-view :class="({isRight: showGoodsUsage})" @tap.stop="valueClick" class="value">{{currencySymbol}}&nbsp;{{displayPrice}}<div class="tips" v-if="(showGoodsUsage)"></div></mpx-view><mpx-view @tap.stop="valueClick" class="order-date">{{ $t('TRADE_UI_local.goodCard.purchasedOn', { time: displayOrderTime }) }}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m93a20e60"}'>
.order-info
  height 100%
  display flex
  flex-flow column nowrap
  justify-content flex-start
  align-items stretch

.value
  font-size 25rpx
  color #282828
  text-align right
  line-height 1.4
  font-family PingFang SC
  font-weight 500
.order-date
  height 17rpx
  font-size 17rpx
  font-family PingFang SC
  font-weight 400
  color #7E7E7E
  text-align right


.value
  margin-top 15rpx
  display flex
  align-items center
  justify-content flex-end
  text-align right
  .tips
    flex-shrink 0
    width 20rpx
    height 20rpx
    background url('https://ut-static.udache.com/webx/fe-agility-wyc/AmLSLZBxhRrQl50bj9E6R_wenhao.png') no-repeat
    background-size 100% 100%
    background-position center
    margin-left 5rpx

.status-text
  font-size 29rpx
  color #FF6C00
  font-family PingFang SC
  font-weight 500
  text-align right
  margin-top -37rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { MixinCurrencySymbol } from '@didi/trade-sdk/lib/quartz.js'
import { timestamp2ymdhms, formatFen2Yuan } from '@didi/trade-sdk'

createComponent({
  name: 'OrderInfo',
  mixins: [ MixinCurrencySymbol ],
  properties: {
    price: Number,
    orderTime: Number,
    statusName: String,
    showGoodsUsage: Boolean,
  },
  computed: {
    displayPrice() {
      return formatFen2Yuan(this.price)
    },
    displayOrderTime() {
      const {
        year,
        month,
        date,
      } = timestamp2ymdhms(this.orderTime * 1000)
      return `${year}.${month}.${date}`
    },
  },
  methods: {
    valueClick() {
      this.triggerEvent('onClick')
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "order_info_dy93a20e60",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
